import React, { Component } from 'react';
import Moment from 'react-moment';
// Bắt buộc import: locale của moment là biến toàn cục, không nạp gói 'vi' thì
// thuộc tính locale="vi" bị bỏ qua và rơi về tiếng Anh ("a few seconds ago").
import 'moment/locale/vi';

import "../css/chatforadminpage.css";

const VERIFIED_ROLES = ["IDOL", "COLLABORATOR", "CUSTOMER-SUPPORTER", "ICOIN-MANAGER", "SINGER"];

function hasVerifiedBadge(message) {
    return message.isAdminIkaraYokara === true || VERIFIED_ROLES.includes(message.role);
}

export default class MessageItem extends Component {
    constructor(props) {
        super(props);
    }


    render() {
        const { message, user, targetUser, handleTargetUser } = this.props;
        
        if (!message || !targetUser) return null;        
        
        var lastMessage = message.lastMessage;

        if (lastMessage instanceof Object) {
            lastMessage = JSON.stringify(lastMessage)
        }

        // Tin đã gửi thì không thể nằm ở tương lai. Bản ghi tạm lúc gửi dùng đồng hồ
        // máy admin (xem sendMessage trong ListChatSupportUser), máy chạy nhanh hơn
        // server bao nhiêu giây thì moment hiện "vài giây tới" đúng bấy nhiêu giây
        // rồi mới tự đổi thành "trước". Kẹp về hiện tại để luôn ra "... trước".
        const now = Date.now();
        const displayDateTime = message.dateTime != null && message.dateTime > now
            ? now
            : message.dateTime;
        const isActive = message.fromUserId == targetUser.fromUserId;
        const isUnread = message.isRead === false
            && String(message.lastUserId || "") !== String(user.facebookId);

        return (
            <>
                <button onClick={() => handleTargetUser(message)} 
                    className={`border border-light list-group-item list-group-item-action rounded-0 conversation-item${isActive ? " active text-white" : " list-group-item-light"}${isUnread ? " unread" : " read"}`}
                    aria-label={`${message.userName || "Hội thoại"}${isUnread ? ", chưa đọc" : ", đã đọc"}`}
                        id={message.lastUserId != user.facebookId ? "lastUserId":""}
                        >
                    <div className="media"><img width={50} className="message-item-img rounded-circle" src={message.userProfile} alt="user"/>
                        <div className="media-body ml-4">
                            <div className="d-flex align-items-center justify-content-between mb-1">
                                <h6 className="mb-0 conversation-user-name">
                                    <span>{message.userName}</span>
                                    {hasVerifiedBadge(message) && (
                                        <span className="verified-badge" title="Tài khoản đã xác minh" aria-label="Tài khoản đã xác minh">
                                            <i className="fa fa-check" aria-hidden="true" />
                                        </span>
                                    )}
                                </h6>
                                <small className="small conversation-time">
                                    {displayDateTime != null && <Moment
                                        fromNow
                                        tz="Asia/Ho_Chi_Minh"
                                        locale="vi"
                                    >{displayDateTime}
                                    </Moment>}
                                </small>
                                <a
                                    href={`${global.config.apiDomain}/admin/account-manager?id=${message.fromUserId}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-link"
                                    style={{ color: 'black' }}
                                >
                                    <i className="fa fa-user" />
                                </a>
                            </div>
                            <p className="font-italic mb-0 text-small">{(lastMessage && lastMessage.length > 35)
                                ? lastMessage.substring(0, 35) + "..."
                                : lastMessage}</p>
                        </div>
                    </div>
                </button>
            </>
        )
    }
}
